<template>
  <v-dialog persistent v-model="mostrar" width="500">
    <l-tela titulo="Adicionar entregador">
      <l-form :salvar="salvar">
        <i-entregador id="entregador" label="Nome" v-model="form.entregador" />
        <template v-slot:botoes>
          <v-btn @click="() => sair(false)">Sair</v-btn>
          <v-btn color="primary" type="submit">Salvar</v-btn>
        </template>
      </l-form>
    </l-tela>
  </v-dialog>
</template>

<script>
import pedidoService from '@/services/pedido.service'
import LoadingMixin from '@/components/Mixins/Loading'
import NotificacaoMixin from '@/components/Mixins/Notificacao'

export default {
  mixins: [LoadingMixin, NotificacaoMixin],
  data() {
    return {
      mostrar: false,
      form: {
        entregador: null,
      },
      pedidoId: null,
      resolve: null,
    }
  },
  methods: {
    async abrir(pedidoId) {
      this.pedidoId = pedidoId
      this.mostrar = true
      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    async salvar() {
      this.mostrarLoading()
      try {
        let pedidoDto = {
          pedidoId: this.pedidoId,
        }

        if (this.form.entregador?._id) {
          pedidoDto = { ...pedidoDto, entregadorId: this.form.entregador._id }
        }

        await pedidoService.adicionarEntregador(pedidoDto)
        this.alertaDadosSalvos()
        this.sair(true)
      } catch (error) {
        this.mostraNotificacao(error)
      } finally {
        this.fecharLoading()
      }
    },
    sair(salvouRegistro) {
      this.limpar()
      this.mostrar = false
      this.resolve(salvouRegistro)
    },
    limpar() {
      this.pedidoId = null
      this.form.entregador = null
    },
  },
}
</script>
